import React, { Component } from 'react'
import "./CounterDown.css";

export default class CounterDown extends Component {

    state = {
        hours: this.props.hours,
        minutes: this.props.minutes,
        seconds: this.props.seconds,
    };

    componentDidMount = () =>{
        this.interval = setInterval(() => {
            const { hours, minutes, seconds } = this.state;
        
            if (hours === 0 && minutes === 0 && seconds === 0) {
                clearInterval(this.interval);
                return;
            }
        
            if (seconds === 0) {
                if (minutes === 0) {
                this.setState(prevState => ({ hours: prevState.hours - 1, minutes: 59, seconds: 59 }));
                } else {
                this.setState(prevState => ({ minutes: prevState.minutes - 1, seconds: 59 }));
                }
            } else {
                this.setState(prevState => ({ seconds: prevState.seconds - 1 }));
            }
        }, 1000);
    }

    componentDidUpdate() {
        const { hours, minutes, seconds } = this.state;
    
        if (hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(this.interval);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { hours, minutes, seconds } = this.state
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        let showHours = null;
        if(hours === 0){
            showHours = false
        }

        return (
            <div className="CounterDown" id="timer">
                {showHours===true?
                <div>
                    <div className="CounterDown_hours">{ formattedHours }</div>
                    <div>:</div>
                </div>
                :null}
                <div className="CounterDown_minutes">{ formattedMinutes }</div>
                <div>:</div>
                <div className="CounterDown_seconds">{ formattedSeconds }</div>
            </div>
        )
    }
}
